module.exports = require('./dist/ReactCrop');


//////////////////
// WEBPACK FOOTER
// ./~/react-image-crop/index.js
// module id = 1473
// module chunks = 0